var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeefoReviewsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffeafc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16386,
    stopColor: "#ffe5aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#fd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d5b00"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.19879,55.849c-.60944.12177-.98865.63116-1.02277,1.1745-.02045.32599.08337.66425.33624.93829l3.08649,3.34485-.53094,4.5202c-.11603.98761.89386,1.72137,1.79724,1.30579l4.13489-1.90179,4.13507,1.90179c.90338.41559,1.91315-.31818,1.79712-1.30579l-.53088-4.5202,3.08649-3.34485c.25287-.27405.35669-.6123.33624-.93829-.03406-.54333-.41333-1.05273-1.02277-1.1745l-3.45361-.69019h0l-1.0094-.20172-2.22742-3.96906c-.48669-.86713-1.73492-.86713-2.22156,0l-2.22742,3.96906-1.0094.20172h0l-3.45361.69019Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.35974,46.51843c.75708.20258,1.45312.57739,2.04803,1.08221h20.19611c-.31824,5.12738-4.38483,9.19397-9.47687,9.51227-.21222.03534-.42438.03534-.6012,0-.24133,0-.47357-.03546-.71075-.05243.00677,1.05402-.29785,2.09271-.89185,2.97687.91937.19104,1.87781.29346,2.87561.29346,7.81494,0,13.54352-6.47119,13.54352-13.82642,0-7.77954-5.55176-13.75568-13.72028-13.75568-7.45807,0-12.91418,5.50299-13.26233,13.76971Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.20117,60.33081c.9978,0,1.95624-.10236,2.87561-.2934-.59344-.88342-.89801-1.92114-.89178-2.9743-.22559.01538-.44611.0498-.67548.0498-.28284.03534-.45966.03534-.63647,0-5.0921-.3183-9.15863-4.38489-9.47693-9.51227h20.19611c.59491-.50488,1.29102-.87964,2.0481-1.08221-.34814-8.26672-5.80426-13.76971-13.26233-13.76971-8.16852,0-13.72034,5.97614-13.72034,13.75568,0,7.35522,5.72864,13.82642,13.54352,13.82642Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeefoReviewsScraper);
export default __webpack_public_path__ + "static/media/feefo-reviews-scraper.c592d141db86dd400b8ea39b7e10bbb4.svg";
export { ForwardRef as ReactComponent };